import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useCurrentLang } from "../hooks/useCurrentLang";
import FAQ from "../components/FAQ.jsx";

import "../styles/globals.css";
import "../styles/layout.css";

export const FAQPage = ({lang = "en"}) => {
    const currentLang = useCurrentLang()
    return (
        <div className="main-layout">
          <Header lang={currentLang} />
          <main>
            <FAQ lang={currentLang} />
          </main>
          <Footer lang={currentLang} />
        </div>
      );
}